module.exports = __webpack_public_path__ + "img/icon_check-user.780f700a.svg";